import React, { Component } from 'react';
import { Row, } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import LinkClicksExpandContainer from 'containers/dashboards/social/LinkClicksExpandContainer';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import { LAYERTHREE } from 'constants/layers';

const calloutSettings = [
    {
        key: 'impressions',
        title: 'Impressions',
        format: '0,0'
    },
    {
        key: 'link_clicks',
        title: 'Link Clicks',
        format: '0,0'
    },
    {
        key: 'cost_per_link_click',
        title: 'Cost per Link Click',
        format: '$0,0.00',
        invert: true
    }
];

class LinkClicksModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social-link-clicks`;
        const { callouts, campaigns, actions } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        const calloutComponents = generateCalloutComponents({
            stub,
            calloutSettings,
            hasCalloutData,
            callouts: {
                ...calloutsData, completeData
            },
            calloutWindow
        });

        return (
            <ObjectiveVisibilityContainer objective={objective} campaigns={campaigns}
                actions={actions} layer={layer} expandContainer={LinkClicksExpandContainer} >
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>
            </ObjectiveVisibilityContainer>
        );
    }
}

LinkClicksModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object
    }).isRequired
};

export default LinkClicksModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/LinkClicksModule.js